import { render, staticRenderFns } from "./Methods1.vue?vue&type=template&id=348cf3ce"
import script from "./Methods1.vue?vue&type=script&lang=js"
export * from "./Methods1.vue?vue&type=script&lang=js"
import style0 from "./Methods1.vue?vue&type=style&index=0&id=348cf3ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports